import styled from 'styled-components';

export const LoginWrapper = styled.div`
  display: flex;
`;
